import type { MatrixEvent, Room } from "matrix-js-sdk";
import { CALL_NOTE } from "src/constants/matrixEventTypes";

const CALL_NOTE_MESSAGE_FIELD = "com.memotivationapp.call_note";

export const isCallNoteEvent = (event: MatrixEvent): boolean => {
    const content = event.getContent<Record<string, unknown>>() || {};

    return event.getType() === CALL_NOTE || Boolean(content[CALL_NOTE_MESSAGE_FIELD]);
};

export const getUnreadCountWithoutCallNotes = (
    room: Room | null | undefined,
    currentUserId: string
): number => {
    const unreadCount = room?.getUnreadNotificationCount?.("total") || 0;
    if (!room || !currentUserId || unreadCount <= 0) {
        return unreadCount;
    }

    const unreadCallNoteCount = (room.getLiveTimeline?.().getEvents?.() || [])
        .filter(event => {
            const eventId = event.getId();
            return Boolean(eventId) &&
                event.getSender() !== currentUserId &&
                isCallNoteEvent(event) &&
                !room.hasUserReadEvent(currentUserId, eventId as string);
        })
        .length;

    return Math.max(0, unreadCount - unreadCallNoteCount);
};
